import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	customerDetails: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		data: {}
	},
	postBrowserDetails: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		result: {}
	},
	postNewMembershipSignup: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		result: {}
	},
	postCheckoutInitial: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		result: {}
	},
	cardDisplayInfo: {
		lastFour: '',
		cardType: ''
	}
};

export const customerDetailsSlice = createSlice({
	name: 'customerDetails',
	initialState,
	reducers: {
		getCustomerDetails: (state) => {
			state.customerDetails.isLoading = true;
		},
		getCustomerDetailsCompleted: (state, action) => {
			state.customerDetails.isLoading = false;
			state.customerDetails.hasCompleted = true;
			state.customerDetails.data = action.payload;
		},
		getCustomerDetailsFailed: (state, action) => {
			state.customerDetails.isLoading = false;
			state.customerDetails.error = action.payload;
		},
		getCustomerDetailsReset: (state) => {
			state.customerDetails = initialState.customerDetails;
		},
		postBrowserDetails: (state) => {
			state.postBrowserDetails.isLoading = true;
		},
		postBrowserDetailsCompleted: (state, action) => {
			state.postBrowserDetails.isLoading = false;
			state.postBrowserDetails.hasCompleted = true;
			state.postBrowserDetails.result = action.payload;
		},
		postBrowserDetailsFailed: (state, action) => {
			state.postBrowserDetails.isLoading = false;
			state.postBrowserDetails.error = action.payload;
		},
		postBrowserDetailsReset: (state) => {
			state.postBrowserDetails = initialState.postBrowserDetails;
		},
		postNewMembershipSignup: (state) => {
			state.postNewMembershipSignup.isLoading = true;
		},
		postNewMembershipSignupCompleted: (state, action) => {
			state.postNewMembershipSignup.isLoading = false;
			state.postNewMembershipSignup.hasCompleted = true;
			state.postNewMembershipSignup.result = action.payload;
		},
		postNewMembershipSignupFailed: (state, action) => {
			state.postNewMembershipSignup.isLoading = false;
			state.postNewMembershipSignup.error = action.payload;
		},
		postNewMembershipSignupReset: (state) => {
			state.postNewMembershipSignup = initialState.postNewMembershipSignup;
		},
		postCheckoutInitial: (state) => {
			state.postCheckoutInitial.isLoading = true;
		},
		postCheckoutInitialCompleted: (state, action) => {
			state.postCheckoutInitial.isLoading = false;
			state.postCheckoutInitial.hasCompleted = true;
			state.postCheckoutInitial.result = action.payload;
		},
		postCheckoutInitialFailed: (state, action) => {
			state.postCheckoutInitial.isLoading = false;
			state.postCheckoutInitial.error = action.payload;
		},
		postCheckoutInitialReset: (state) => {
			state.postCheckoutInitial = initialState.postCheckoutInitial;
		},
		setCardDisplayInfo: (state, action) => {
			state.cardDisplayInfo = action.payload;
		},
		clearCardDisplayInfo: (state) => {
			state.cardDisplayInfo = initialState.cardDisplayInfo;
		}
	}
});

export const {
	getCustomerDetails,
	getCustomerDetailsCompleted,
	getCustomerDetailsFailed,
	getCustomerDetailsReset,
	postBrowserDetails,
	postBrowserDetailsCompleted,
	postBrowserDetailsFailed,
	postNewMembershipSignup,
	postNewMembershipSignupCompleted,
	postNewMembershipSignupFailed,
	postNewMembershipSignupReset,
	postCheckoutInitial,
	postCheckoutInitialCompleted,
	postCheckoutInitialFailed,
	postCheckoutInitialReset,
	setCardDisplayInfo,
	clearCardDisplayInfo
} = customerDetailsSlice.actions;

export default customerDetailsSlice.reducer;
